import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useUiuxStore from "src/store/useUiuxStore";
import { Content_PRD4011_R01 } from "./Content_PRD4011_R01";
import { SearchSection_PRD4011_R01 } from "./SearchSection_PRD4011_R01";
import { LineCard_PRD4011_R01 } from "./LineCard_PRD4011_R01";
import { PlcStatus_PRD4011_R01 } from "./PlcStatus_PRD4011_R01";
import { ErrorAlarmModal_PRD4011_R01 } from "./ErrorAlarmModal_PRD4011_R01";
import { usePRD4011_R01Store } from "./Store_PRD4011_R01";

export const Container_PRD4011_R01 = () => {
    const { setMessage } = useUiuxStore();
    const { fetchData, handleInitClick, handleAlarmConfirmClick } = Content_PRD4011_R01({
        setMessage,
    });
    const { PRD4011_R01List, PRD4011_R01PlcStatusList, PRD4011_R01AlarmList } =
        usePRD4011_R01Store();

    const supplyIsRunning = PRD4011_R01PlcStatusList.some(
        (plcStatus) => plcStatus.equipNm === "공급부" && plcStatus.isPowerOn
    );
    const dischargeIsRunning = PRD4011_R01PlcStatusList.some(
        (plcStatus) => plcStatus.equipNm === "배출부" && plcStatus.isPowerOn
    );

    return (
        <div className="content-container flex flex-col h-full min-h-0">
            <Actionbar
                onFetchClick={() => {
                    void fetchData(false);
                }}
                onSaveClick={undefined}
                onDeleteClick={() => {}}
                onInitClick={handleInitClick}
                onPrintClick={() => {}}
            />

            <SearchSection_PRD4011_R01 />

            <div className="flex-1 min-h-0 overflow-auto">
                <div className="flex flex-col gap-4 p-3">
                    {/* PLC 상태 */}
                    <div className="grid grid-cols-2 gap-4">
                        {PRD4011_R01PlcStatusList.map((plcStatus) => (
                            <PlcStatus_PRD4011_R01
                                key={plcStatus.minorCd}
                                data={plcStatus}
                            />
                        ))}
                    </div>

                    {/* 라인별 생산현황 */}
                    <div className="grid grid-cols-2 gap-4">
                        {PRD4011_R01List.map((workplace) => (
                            <LineCard_PRD4011_R01
                                key={workplace.workplaceCd}
                                data={workplace}
                                supplyIsRunning={supplyIsRunning}
                                dischargeIsRunning={dischargeIsRunning}
                            />
                        ))}
                    </div>

                    <div className="text-right text-[22.5px] text-[#5a6577]">
                        데이타제공 - 라온정보기술 T.053-283-7000 / H.010-5154-6264
                    </div>
                </div>
            </div>

            <ErrorAlarmModal_PRD4011_R01
                alarmList={PRD4011_R01AlarmList}
                onConfirm={handleAlarmConfirmClick}
            />

            <Message />
        </div>
    );
};
